module.exports = __webpack_public_path__ + "img/ZAR10028.dcd39a6e.png";